var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-password-reset.ts
import "@adornis/base/utilTypes.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { XSnackbar } from "@adornis/chemistry/elements/components/x-snackbar.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { routingState } from "@adornis/router/client/routing-state.js";
import { AdornisUser } from "@adornis/users/db/a-user.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
var XPasswordReset = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.rerouteAfterSuccess = new RXController(
      this,
      routingState.searchParams.get("reroute")
    );
    this.passwordResetInstructions = "Hier k\xF6nnen Sie ein neues Passwort vergeben. Beachten Sie, dass Ihr Passwort mindestens die folgenden Bedingungen erf\xFCllen muss.";
    this.passwordResetSuccessMessage = "Ihr Passwort wurde erfolgreich ge\xE4ndert. Sie k\xF6nnen diese Seite nun verlassen.";
    this._token = new RXController(this, routingState.searchParams.get("token"));
    this._firstPassword = "";
    this._repeatedPassword = "";
    this._errorMessage = "";
    this._passwordGotChanged = false;
    this._loading = false;
  }
  render() {
    return xComponents(html`
      <x-flex center crossaxis-center ${css({ width: "100%", height: "100%" })}>
        <slot id="image"></slot>
        <x-flex center crossaxis-center space="xl" ${css({ maxWidth: "40rem" })}>
          <x-flex space="md" center crossaxis-center>
            <x-h4>Passwort ändern</x-h4>
            ${this._errorMessage ? html`<x-text ${css({ textAlign: "center" })} tone="error">${this._errorMessage}</x-text>` : nothing}
            ${this._getPasswordResetState()}
          </x-flex>
        </x-flex>
      </x-flex>
    `);
  }
  _getPasswordResetState() {
    if (!this._token.value || this._loading)
      return this.loadingState();
    if (this._passwordGotChanged)
      return this.successfullyChangedPasswordState();
    return this.changePasswordState();
  }
  loadingState() {
    return xComponents(html` <x-loader></x-loader> `);
  }
  successfullyChangedPasswordState() {
    return xComponents(
      html`
        <x-text ${css({ textAlign: "center" })}> ${this.passwordResetSuccessMessage} </x-text>
        <x-button href="/"> Weiter </x-button>
      `
    );
  }
  changePasswordState() {
    return xComponents(html`
      <x-text ${css({ textAlign: "center" })}> ${this.passwordResetInstructions} </x-text>
      <x-component-password-checker .password=${this._firstPassword}></x-component-password-checker>
      <x-input
        placeholder="Passwort"
        type="password"
        @value-changed=${(e) => this._firstPassword = e.detail.value}
      ></x-input>
      <x-input
        type="password"
        placeholder="Passwort wiederholen"
        @value-changed=${(e) => this._repeatedPassword = e.detail.value}
        @submit=${() => this._changePassword()}
      ></x-input>
      <x-button mode="action" @click=${() => this._changePassword()}> Fertig! </x-button>
    `);
  }
  async _changePassword() {
    if (this._firstPassword !== this._repeatedPassword) {
      this._errorMessage = "Die Passw\xF6rter stimmen nicht \xFCberein!";
      return;
    }
    try {
      const result = await AdornisUser.changePasswordWithToken(this._token.value, this._firstPassword)();
      if (result) {
        void XSnackbar.show("Dein Passwort wurde erfolgreich ge\xE4ndert");
        this._passwordGotChanged = true;
        if (this.rerouteAfterSuccess.value) {
          setTimeout(() => {
            goTo(this.rerouteAfterSuccess.value, { target: "_parent" });
          }, 1e3);
        }
      }
    } catch (e) {
      this._errorMessage = e.message;
    }
  }
};
__decorateClass([
  property({ attribute: false })
], XPasswordReset.prototype, "rerouteAfterSuccess", 2);
__decorateClass([
  state()
], XPasswordReset.prototype, "_token", 2);
__decorateClass([
  state()
], XPasswordReset.prototype, "_firstPassword", 2);
__decorateClass([
  state()
], XPasswordReset.prototype, "_repeatedPassword", 2);
__decorateClass([
  state()
], XPasswordReset.prototype, "_errorMessage", 2);
__decorateClass([
  state()
], XPasswordReset.prototype, "_passwordGotChanged", 2);
__decorateClass([
  state()
], XPasswordReset.prototype, "_loading", 2);
XPasswordReset = __decorateClass([
  customElement("x-password-reset")
], XPasswordReset);
var XComponentPasswordHelper = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.password = "";
  }
  styles() {
    return [
      ...super.styles(),
      {
        ".correct": {
          color: this.colors.on.primary
        },
        ".wrong": {
          color: this.colors.tone.error
        }
      }
    ];
  }
  render() {
    const lenghtOK = this.password.length >= 8;
    const lowercaseOK = /(?=.*[a-z])/.test(this.password);
    const uppercaseOK = /(?=.*[A-Z])/.test(this.password);
    const specialOK = /(?=.*\W)/.test(this.password);
    const numberOK = /(?=.*\d)/.test(this.password);
    return xComponents(html`
      <x-flex center space="md">
        <x-flex class="${lenghtOK ? "correct" : "wrong"}" horizontal space="sm">
          <x-icon> ${lenghtOK ? "check" : "error_outline"} </x-icon>
          <x-text> Mindestens 8 Zeichen </x-text>
        </x-flex>
        <x-flex class="${lowercaseOK ? "correct" : "wrong"}" horizontal space="sm">
          <x-icon> ${lowercaseOK ? "check" : "error_outline"} </x-icon>
          <x-text> Ein Kleinbuchstabe </x-text>
        </x-flex>
        <x-flex class="${uppercaseOK ? "correct" : "wrong"}" horizontal space="sm">
          <x-icon> ${uppercaseOK ? "check" : "error_outline"} </x-icon>
          <x-text> Ein Großbuchstabe </x-text>
        </x-flex>
        <x-flex class="${numberOK ? "correct" : "wrong"}" horizontal space="sm">
          <x-icon> ${numberOK ? "check" : "error_outline"} </x-icon>
          <x-text> Eine Zahl </x-text>
        </x-flex>
        <x-flex class="${specialOK ? "correct" : "wrong"}" horizontal space="sm">
          <x-icon> ${specialOK ? "check" : "error_outline"} </x-icon>
          <x-text> Ein Sonderzeichen </x-text>
        </x-flex>
      </x-flex>
    `);
  }
};
__decorateClass([
  property()
], XComponentPasswordHelper.prototype, "password", 2);
XComponentPasswordHelper = __decorateClass([
  customElement("x-component-password-checker")
], XComponentPasswordHelper);
export {
  XComponentPasswordHelper,
  XPasswordReset
};
